<dx-data-grid biz-grid [dataSource]='items' [bizSetAllowColumnReordering]="false" [columnAutoWidth]="true"
    noDataText="No change log entries found" [masterDetail]="{ enabled: true, template: 'masterDetail' }">

    <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>

    <dxi-column dataField="CreatedDate" caption="Timestamp" dataType="date" sortOrder="desc" width="auto"
        [allowGrouping]="false" [format]="dateTimeService.getDevExpressDateTimeWithMsFunction"></dxi-column>
    <dxi-column dataField="CreatedBy" caption="User" dataType="string" width="auto">
        <dxo-lookup [dataSource]="users" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="LogAction" caption="Action" dataType="string" width="auto">
        <dxo-lookup [dataSource]="logActions" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="EntityDisplayName" caption="Type" dataType="string" width="auto"></dxi-column>
    <dxi-column dataField="EntityDisplayValue" caption="Name" dataType="string"></dxi-column>

    <ng-container *dxTemplate="let rowInfo of 'masterDetail'">
        <app-change-log-viewer-details [item]="rowInfo.data"></app-change-log-viewer-details>
    </ng-container>
</dx-data-grid>
